export default __webpack_public_path__ + "static/media/art4.8bb76d89.jpg";